"use client";

import { useAuth } from "@clerk/nextjs";

export const ImpersonationBanner = () => {
  const { userId, actor, isSignedIn, isLoaded } = useAuth();

  if (!isLoaded || !isSignedIn || !actor) {
    return null;
  }

  return (
    <div className="bg-[repeating-linear-gradient(45deg,_var(--pattern-fg)_0,_var(--pattern-fg)_4px,_transparent_0,_transparent_50%)] bg-[size:15px_15px] bg-fixed p-2 text-center text-black [--pattern-fg:#fbcd40]">
      Bruker ${actor.sub} er logget inn som bruker ${userId}.
    </div>
  );
};
